// Auto-generated — do not edit
import { i18nBundle } from '@amzn/bf-i18n'
import type { InactivityModalGetString, ErrorModalsGetString, DynamicMessageModalTemplateGetString, DynamicMessageBannerTemplateGetString, DefaultFallbackMessagesGetString, CsatSurveyModalGetString, CsatSurveyHeaderGetString, CookieConsentModalGetString, DynamicMessagingPaymentWidgetGetString, DailyChangeLimitModalGetString } from './types.generated'

const inactivityModalLocales = ['en-US'] as const

export const getStringInactivityModal: InactivityModalGetString = i18nBundle('inactivityModal', inactivityModalLocales).getString

const errorModalsLocales = ['en-US'] as const

export const getStringErrorModals: ErrorModalsGetString = i18nBundle('errorModals', errorModalsLocales).getString

const dynamicMessageModalTemplateLocales = ['en-US'] as const

export const getStringDynamicMessageModalTemplate: DynamicMessageModalTemplateGetString = i18nBundle('dynamicMessageModalTemplate', dynamicMessageModalTemplateLocales).getString

const dynamicMessageBannerTemplateLocales = ['en-US'] as const

export const getStringDynamicMessageBannerTemplate: DynamicMessageBannerTemplateGetString = i18nBundle('dynamicMessageBannerTemplate', dynamicMessageBannerTemplateLocales).getString

const defaultFallbackMessagesLocales = ['en-US'] as const

export const getStringDefaultFallbackMessages: DefaultFallbackMessagesGetString = i18nBundle('defaultFallbackMessages', defaultFallbackMessagesLocales).getString

const csatSurveyModalLocales = ['en-US'] as const

export const getStringCsatSurveyModal: CsatSurveyModalGetString = i18nBundle('csatSurveyModal', csatSurveyModalLocales).getString

const csatSurveyHeaderLocales = ['en-US'] as const

export const getStringCsatSurveyHeader: CsatSurveyHeaderGetString = i18nBundle('csatSurveyHeader', csatSurveyHeaderLocales).getString

const cookieConsentModalLocales = ['en-US'] as const

export const getStringCookieConsentModal: CookieConsentModalGetString = i18nBundle('cookieConsentModal', cookieConsentModalLocales).getString

const dynamicMessagingPaymentWidgetLocales = ['en-US'] as const

export const getStringDynamicMessagingPaymentWidget: DynamicMessagingPaymentWidgetGetString = i18nBundle('DynamicMessagingPaymentWidget', dynamicMessagingPaymentWidgetLocales).getString

const dailyChangeLimitModalLocales = ['en-US'] as const

export const getStringDailyChangeLimitModal: DailyChangeLimitModalGetString = i18nBundle('DailyChangeLimitModal', dailyChangeLimitModalLocales).getString

